// extracted by mini-css-extract-plugin
export var searchHeader = "_32-0";
export var searchHeaderDark = "_32-1";